import { doDelete, doGet, doPost, doPut } from '../services/http';
import { deleteProfileImage, profileUpload, searchSupportUsers, groupsFilter, uploadAttachments, getPusherCred, tokenInvalidate, logout } from './urls';
const {
  BASE_URL
} = process.env || {};
export const fetchChatConfigApi = url => doGet(url, {
  source: 'tap'
});
export const getChatAccessTokenApi = (url, data) => doPost(url, data);
export const fetchNotificationApi = (url, data, tokenInfo) => doPost(url, data, null, tokenInfo);
export const updateNotificationApi = (url, data, tokenInfo) => doPut(url, data, tokenInfo);
export const getEncryptionKeyApi = url => doGet(url);
export const fetchUserConfig = url => doGet(url);
export const addTodoApi = (url, data) => doPut(url, data);
export const uploadUserImageApi = (apiBaseUrl, data) => doPost("".concat(apiBaseUrl).concat(profileUpload), data, {});
export const removeUserImageApi = apiBaseUrl => doDelete("".concat(apiBaseUrl).concat(deleteProfileImage));
export const fetchPusherCred = apiBaseUrl => doGet("".concat(apiBaseUrl).concat(getPusherCred));
export const invalidateAccessTokenApi = () => doPut("".concat(BASE_URL).concat(tokenInvalidate), {});
export const logoutFromToken = () => doPost("".concat(BASE_URL).concat(logout), {});

// Support Portal Add Ticket Apis
export const fetchSupportBrandsApi = url => doGet(url);
export const createTicketApi = function (url, data) {
  let dealerId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  let header = null;
  let dataObj = data;
  if (dealerId > 0) {
    dataObj = JSON.stringify(data);
    header = {
      'Content-Type': 'application/json; charset=UTF-8',
      dealer: dealerId
    };
  }
  return doPost(url, dataObj, header);
};
export const fetchTicketCreationFieldsApi = url => doGet(url);
export const fetchTicketFieldsApi = url => doGet(url);
export const uploadAttachmentApi = data => doPost("".concat(BASE_URL).concat(uploadAttachments), data, {});
export const fetchGroupLookUpApi = key => doPost("".concat(BASE_URL).concat(groupsFilter), {
  name_only_search: false,
  search_key: key
});
export const searchUsersApi = key => doGet("".concat(BASE_URL).concat(searchSupportUsers).concat(key));